import { ActivatedRouteSnapshot, Params, RouterStateSnapshot, Routes } from '@angular/router'
import { createFeatureSelector } from '@ngrx/store'
import * as fromRouter from '@ngrx/router-store'

import { NotFoundComponent } from './not-found.component'

export const appRoutes: Routes = [
  {path: '', pathMatch: 'full', redirectTo: 'chat'},
  {path: 'chat', loadChildren: './chat/chat.module#ChatModule', data: {module: 'chat'}},
  {path: 'login', loadChildren: './login/login.module#LoginModule'},
  {path: 'auth', loadChildren: './auth/auth.module#AuthModule'},
  {path: 'teams', loadChildren: './teams/teams.module#TeamsModule', data: {module: 'teams'}},
  {path: 'report', loadChildren: './reports/reports.module#ReportsModule'},
  {path: 'rights', loadChildren: './rights/rights.module#RightsModule'},
  {path: 'profile', loadChildren: './profile/profile.module#ProfileModule'},
  {path: '**', component: NotFoundComponent}
]

export interface RouterStateUrl {
  url: string
  queryParams: Params
  params: Params
  module: string
}

export const getRouterState = createFeatureSelector<fromRouter.RouterReducerState<RouterStateUrl>>('routerReducer')

export class CustomSerializer
  implements fromRouter.RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    const {url} = routerState
    const {queryParams} = routerState.root

    let state: ActivatedRouteSnapshot = routerState.root
    while (state.firstChild) {
      state = state.firstChild
    }
    const {params, data} = state

    return {url, queryParams, params, module: data.module}
  }
}




// WEBPACK FOOTER //
// ./src/app/app.routing.ts